import { Dialog, DialogContent } from '../ui/Dialog';
import { t } from '../../i18n';

const SHORTCUTS: Array<{ keys: string; labelKey: string }> = [
  { keys: 'Ctrl/⌘ + Z', labelKey: 'editor.shortcuts.undo' },
  { keys: 'Ctrl/⌘ + Shift + Z', labelKey: 'editor.shortcuts.redo' },
  { keys: 'Delete / Backspace', labelKey: 'editor.shortcuts.delete' },
  { keys: 'Ctrl/⌘ + D', labelKey: 'editor.shortcuts.duplicate' },
  { keys: 'Esc', labelKey: 'editor.shortcuts.escape' },
  { keys: 'Enter', labelKey: 'editor.shortcuts.enter' },
  { keys: 'Ctrl/⌘ + S', labelKey: 'editor.shortcuts.save' },
  { keys: 'Ctrl/⌘ + "+"', labelKey: 'editor.shortcuts.zoomIn' },
  { keys: 'Ctrl/⌘ + "-"', labelKey: 'editor.shortcuts.zoomOut' },
  { keys: ']', labelKey: 'editor.shortcuts.nextPage' },
  { keys: '[', labelKey: 'editor.shortcuts.prevPage' },
];

export function ShortcutsDialog({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent title={t('editor.shortcuts.title')}>
        <table className="shortcuts-table">
          <tbody>
            {SHORTCUTS.map((s) => (
              <tr key={s.labelKey}>
                <td>
                  <kbd>{s.keys}</kbd>
                </td>
                <td>{t(s.labelKey)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </DialogContent>
    </Dialog>
  );
}
